export default "__VITE_ASSET__BtYYvwoj__"